import APIRequest from './APIRequest';

export const GetCancellationJobs = () => {
    return APIRequest({
        url: `api/Job/GetCancellationJobs`,
        method: 'get'
    });
};
export const GetRevenueBoard = (filters) => {
    return APIRequest({
        url: `api/Job/GetRevenueBoard`,
        method: 'post',
        body: filters
    });
};

export const GetRevenueBoardCsv = (filters) => {
    return APIRequest({
        url: `api/Job/GetRevenueBoardCsv`,
        method: 'post',
        body: filters,
        responseType: 'blob'
    });
};

export const GetTeams = () => {
    return APIRequest({
        url: `api/Job/GetTeams`,
        method: 'get'
    });
};